<template>
  <div class="view" v-if="canView" v-cloak>
    <card :title="$t('apia.farm_register')" id="cultures"> 
      <div style="min-height:300px;display:flex;flex-direction:column;align-items:center;justify-content:center;text-align:center;gap:12px;">
        <div style="font-size:56px;line-height:1">🚧</div>
        <h2 style="margin:0;">Under construction</h2>
        <p style="margin:0;opacity:.8;">This page is being built. Please check back soon.</p>
      </div>
    </card>
  </div>
  <forbidden v-else />
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import DxDataGrid, {
  DxColumn,
  DxPaging,
  DxPager,
  DxHeaderFilter,
  DxFilterRow,
  DxSelection,
  DxButton,
  DxPopup,
  DxToolbar,
  DxItem,
  DxExport,
} from "devextreme-vue/data-grid";
import { canView, canDelete, canEdit, permissions, permissionTypes } from "~/helpers/Permissions";
import Forbidden from "~/pages/errors/Forbidden.vue";
import DataSource from "devextreme/data/data_source";
import CustomStore from "devextreme/data/custom_store";
import { format } from "date-fns";
import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import { saveAs } from "file-saver-es";

export default {
  name: "FarmRegister",
  components: {
    DxDataGrid,
    DxColumn,
    DxHeaderFilter,
    DxFilterRow,
    DxSelection,
    DxButton,
    DxPaging,
    DxPager,
    DxPopup,
    DxToolbar,
    DxItem,
    Forbidden,
    DxExport,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({}),
    config() {
      return {
        permission: permissions.APIA,
        permission_type: permissionTypes.access,
      };
    },
    canView() {
      return canView(this);
    },
    canEdit() {
      return canEdit(this);
    },
    canDelete() {
      return canDelete(this);
    },
  },
  methods: {
    ...mapActions({}),
  },
  mounted() {},
};
</script>
